import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { LoginGuard } from '../auth/loginGuard';
import { CallCenterAppointmentComponent } from './call-center-appointment/call-center-appointment.component';
import { CallCenterLayoutComponent } from './call-center-layout/call-center-layout.component';
import { CallCenterComponent } from './call-center.component';
import { CallCenterDashboardComponent } from './call-center-dashboard/call-center-dashboard.component';
import { FindCareComponent } from '../shared/components/find-care/find-care.component';
import { CallCenterMembersSearchComponent } from './call-center-members-search/call-center-members-search.component';

const routes: Routes = [
  {
    path: 'callcenter',
    component: CallCenterLayoutComponent,
    children: [
      { path: '', redirectTo: "/callcenter/dashboard", pathMatch: "full" },
      {
        path: 'dashboard',
        component: CallCenterDashboardComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'memberserach',
        component: CallCenterMembersSearchComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'findcare',
        component: FindCareComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'findcare/:categoryId',
        component: FindCareComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'appointmentlist',
        component: CallCenterComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'appointment',
        component: CallCenterAppointmentComponent,
        canActivate: [LoginGuard],
      }
    ]
  }];

@NgModule({
  imports: [ReactiveFormsModule, RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CallCenterRoutingModule { }
